import { useNavigate } from 'react-router-dom';
import { DoorClosed } from 'lucide-react';

import { useT } from '../i18n';
import { useManDauTien } from '../hooks/useManDauTien';

/**
 * Màn báo đường dẫn thuộc cổng khác.
 *
 * Khác `ForbiddenView`: màn đó nói "bạn thiếu quyền", hàm ý xin thêm quyền là
 * vào được. Ở đây không phải vậy — màn thuộc cổng kia, xin quyền cũng không
 * mở ra, nên câu chữ phải nói đúng chuyện đó và chỉ lối về.
 *
 * Nút đưa thẳng về màn đầu tiên của cổng người dùng, không phải `quay lại`:
 * tới được đây thường là do dấu trang hoặc liên kết cũ, nên trang trước đó
 * cũng sai cổng và `quay lại` sẽ dội về đúng màn này.
 */
export function SaiCongView() {
  const navigate = useNavigate();
  const { t } = useT();
  const manDauTien = useManDauTien();

  return (
    <div className="flex h-full min-h-[60vh] flex-col items-center justify-center px-6 text-center">
      <div className="mb-5 flex h-16 w-16 items-center justify-center rounded-full bg-warning-50">
        <DoorClosed size={32} className="text-warning-500" />
      </div>
      <h1 className="mb-2 text-xl font-bold text-content-primary">{t('chan.saiCongTieuDe')}</h1>
      <p className="mb-6 max-w-sm text-sm text-content-secondary">{t('chan.saiCongMo')}</p>
      <button
        type="button"
        onClick={() => navigate(manDauTien, { replace: true })}
        className="rounded-lg bg-primary-600 px-4 py-2 text-sm font-medium text-white transition-colors hover:bg-primary-700"
      >
        {t('chan.veManDauTien')}
      </button>
    </div>
  );
}
